import { render, staticRenderFns } from "./HotelHighlightList.vue?vue&type=template&id=43baf80f&"
import script from "./HotelHighlightList.vue?vue&type=script&lang=js&"
export * from "./HotelHighlightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports